import { useLocation } from 'react-router-dom';

const ssrFallback = { pathname: '', search: '', hash: '', state: null, key: 'default' };

/**
 * SSR-safe wrapper around useLocation.
 * During SSR (no Router context), useLocation throws — this hook
 * catches that and returns a fallback location object instead.
 *
 * On the client (inside BrowserRouter), this is a transparent passthrough.
 */
const useSafeLocation = () => {
    try {
        return useLocation();
    } catch {
        return ssrFallback;
    }
};

export default useSafeLocation;
